import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function localesReducer(state = initialState.locales, action: any) {
  switch (action.type) {
    case types.SAVE_LOCALES_SUCCESS:
      return action.locales;
    default:
      return state;
  }
}
